import { QuestionSalesTermWithQuestionForMain as Question } from "@/components/features/items/edit/_shared/ui/components/main/questions/sales-term/sales-term-with-question-for-main";

import { useVoucherSalesTerm } from "./hooks";

export const QuestionSalesTerm = () => {
	const {
		isLimitedSale,

		saleTypeForTerm,
		saleTypeForTermOptions,
		onSetSaleTypeForTerm,

		saleStart,
		saleEnd,
		onSetSaleTerm,
	} = useVoucherSalesTerm();

	const title = "販売期間";
	const guide =
		"宿泊券の販売期間を設定しましょう。<br />期間限定を選択した場合、公開期間中に予約された宿泊可能期間に滞在する予約でのみ宿泊券が購入可能になります。<br />こちらの設定は在庫設定で上書き可能です。";

	return (
		<Question
			required={true}
			title={title}
			guide={guide}
			saleTypeForTerm={saleTypeForTerm}
			saleTypeForTermOptions={saleTypeForTermOptions}
			onSetSaleTypeForTerm={onSetSaleTypeForTerm}
			saleStart={saleStart}
			saleEnd={saleEnd}
			onSetSaleTerm={onSetSaleTerm}
			isLimitedSale={isLimitedSale}
		/>
	);
};

QuestionSalesTerm.displayName = "QuestionSalesTerm";
